import { render } from "./NameBox.vue?vue&type=template&id=4dc0e276&scoped=true"
import script from "./NameBox.vue?vue&type=script&lang=js"
export * from "./NameBox.vue?vue&type=script&lang=js"

import "./NameBox.vue?vue&type=style&index=0&id=4dc0e276&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4dc0e276"

export default script